import { Grid, Card } from '@scuf/common'
import { useNavigate } from 'react-router-dom'
import './Dashboard.css'
import React from 'react'
import { fetchKeyFromKeyVault, getOperationPermissions } from '../redux/actionCreator'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { useAuth } from 'react-oidc-context'
import { type OperationPermissionState } from '../redux/operationPermissionSlice'
import { type RootState } from '../../../store'
import LanguageStrings from '../../../i18n/locales'
import { useNav } from '../../../App'
import { getMenuItemsForSubApp } from '../../../utils/AppUtil'

const dashbpardStrings = LanguageStrings().Dashboard

const Dashboard = (props: PropsFromRedux): JSX.Element => {
  const navigate = useNavigate()
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const keyVaultState = useSelector((state: RootState) => state.keyVaultState)
  const auth = useAuth()
  const { setShowSidebar, setMenuItems, setActiveSubAppId, setLastActiveItemId } = useNav()

  // Hide sidebar on dashboard
  React.useEffect(() => {
    setShowSidebar(false)
  }, [])

  React.useEffect(() => {
    if (location.pathname === '/') {
      setActiveSubAppId(null)
    }
  }, [location.pathname])

  const handleAmiOperationsHub = (): void => {
    setShowSidebar(true)
    setMenuItems(getMenuItemsForSubApp('isense'))
    setActiveSubAppId('isense')
    setLastActiveItemId('home')
    navigate('/isense')
  }

  const handleDataPublisher = (): void => {
    setShowSidebar(true)
    sessionStorage.setItem('currentSessionTab', '0')
    navigate('/datapub')
    setMenuItems(getMenuItemsForSubApp('datapub'))
    setActiveSubAppId('datapub')
    setLastActiveItemId('home')
  }

  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
    if (keyVaultState.keys.GOOGLE_MAPS_API_KEY === '') {
      props.fetchKeyFromKeyVault('GOOGLE-API-KEY', 'GOOGLE_MAPS_API_KEY')
    }
  }, [])

  return (
        <Grid data-testid='dashboard-tiles'>
            <Grid.Row>
                <Grid.Column width={12}>
                    <h1 style={{ fontWeight: 700, marginTop: '0.5em', marginBottom: '0.4em' }}>Honeywell Forge Performance+ for Utilities</h1>
                </Grid.Column>
                <Grid.Row>
                    <Grid.Column width={4} mWidth={6} sWidth={12}>
                        <Card className="dashboard-card ami" onClick={handleAmiOperationsHub}>
                            <Card.Content className=' admin-card-titles'>HONEYWELL FORGE PERFORMANCE+ FOR UTILITIES | AMI OPERATIONS HUB</Card.Content>
                        </Card>
                    </Grid.Column>
                    {
                      operationPermissions.permissions.can_read_report_template
                        ? (
                        <Grid.Column width={4} mWidth={6} sWidth={12}>
                            <Card className="dashboard-card data-publisher" onClick={handleDataPublisher} data-testid='publisherTab'>
                                <Card.Content className=' admin-card-titles'>{dashbpardStrings.DataPublisher}</Card.Content>
                            </Card>
                        </Grid.Column>
                          )
                        : null
                    }
                    <Grid.Column width={4} mWidth={6} sWidth={12}>
                    <a
                        href={typeof window._env_?.REACT_APP_FORGE_IAM_ADMIN_CARD === 'string' ? window._env_.REACT_APP_FORGE_IAM_ADMIN_CARD : ''}
                        data-testid='admin_link'
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <Card className="dashboard-card admin">
                            <Card.Content className=' admin-card-titles'>{dashbpardStrings.ADMIN}</Card.Content>
                        </Card>
                    </a>
                    </Grid.Column>
                </Grid.Row>
            </Grid.Row>
        </Grid>
  )
}

interface DispatchToProps {
  getOperationPermissions: (sub: string) => void
  fetchKeyFromKeyVault: (keyVaultKey: string, keyName: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub)),
  fetchKeyFromKeyVault: (keyVaultKey: string, keyName: string) => dispatch(fetchKeyFromKeyVault(keyVaultKey, keyName))
})

const connector = connect(null, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
export default connector(Dashboard)
